// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CK-b","label":"styles_label__1C0_b"};